import { defineComponent as _defineComponent } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LinkButton',
    props: {
        icon: String
    },
    setup(__props, { expose }) {
        expose();
        const __returned__ = { get Link() { return Link; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
